// removed by extract-text-webpack-plugin
module.exports = {"root":"Toolbox__root___1iV6i","title":"Toolbox__title___1JWnO","row":"Toolbox__row___2_hkq","colorPicker":"Toolbox__colorPicker___18LHo","label":"Toolbox__label___1yE2N","fontSize":"Toolbox__fontSize___1gDkm","fontStyle":"Toolbox__fontStyle___1aqq8","fontStylePickerItem":"Toolbox__fontStylePickerItem___1mUAx","fontStylePickerItemActive":"Toolbox__fontStylePickerItemActive___24lH4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Label/Toolbox/Toolbox.scss
// module id = 990
// module chunks = 0